import { privacyCheck } from '../action/change/checkout';
import { CheckOut, MTNValidation } from './../constants/actionType'

const initialState = {
    
    mvCheckout: null,
    storedetailslist : null,
    isLoaderActive: false,
    isValidateCart: false,
    skipAutoPay: false,

    //checkout steps accordion
    activeStep: 2,
    completedStep: [false, false, false, false, false, false, false],

    //begin install related
    //from prod - part of response for validateCredit API call
    backendFailure: "",
    creditRespose: null,
    isCreditCheckDone: false,
    GDDInstType: "",//"EONTSTOREPICKUP",    
    dueDateResponse: null,//tempInstallationRespData.data.duedates,
    setUpFeeText_Self: "",
    expeditedShippingDate: false,
    isSameDayDeliveryAvbl: false,
    //end

    dueDateArr: null,//tempInstallationRespData.data.duedates.map(obj => { return obj.dueDate; }),
    dueDateArr_Tech:null,
    selfMailDateArr: [],//tempInstallationRespData.data.duedates.map(obj => { return obj.dueDate; }),
    selfPickupDateArr: [],//tempInstallationRespData.data.duedates.map(obj => { return obj.dueDate; }),
    installTimeSlots: null,//tempInstallTimeSlotData,
    storePickupType: "",
    eligibleInstallation: "TechOnly",
    isInstallationDone: false,
    displayResetDueDateMsg: false,
    resetDDattemptExceeded: false,

    isPrepaidFlow: false,
    isDSLflow: false,
    isOnlyFEflow: false,
    isFlashSaleEligible: false,
    isStorePickupEnabled: false,

    tRollRC: "",
    enableDueDateMessage: "",
    isSelfInstallOfferInCart: false,
    partialPaymentText: "",

    storeLocations: null,//tempStoreLocations,
    isPackageLockerAvailable: false,
    packageLockerLocation: null,
    lockerdueDateArr: null,
    calenderDisplayArr: null,

    //for techvisit only
    directShipDates: null,//tempDirectShipDates,
    showDirectShipSection: false,
    dsInput: "",
    isOneOrTwoHrSlot: true,
    hourText: "",
    switchInstallOptions: true,
    selInstallDate: "",
    selInstallDateFormatted: "",
    selInstallTimeSlot: "",
    selInstallTimeSlotReserved: "",
    intervalReason: '',
    fiabSelectedOption: 'YES',
    selDueDateType: "",
    selDueDateType_new:"",
    selDeliveryOption: "Mail",
    selEarliestDate: "",
    satelliteSelect: "",
    satelliteClick: false,
    satelliteEligible: "N",
    isDueDateCall: false,
    //end install related
    ftcCheck: false,
    tosCheck: false,
    tosMSDCheck: false,
    privacyCheck: false,
    hdpCheck: false,
    homeSecurityCheck: false,
    homeSecureCheck: false,
    showTosError: false,
    showTosVoiceError: false,
    showTosVHDPError: false,
    tosVoiceCheck: false,
    tosViewed: false,
    isautopayenrollincheckout:false,
    tosAccordionOpen: false,
    accordionStatus: {
        personalInfo: 'required',
        satellite: 'required',
        creditCheck: 'required',
        installation: 'required',
        autoPay: 'required',
        reviewOrder: 'required',
        tos: 'required',
        deposit: 'required',
        //move Change
        returnEquipment: 'required',
        disconnect: 'required',
        deliveryOption:'required'
        
    },
    //PaperFreeBilling and AutoPay Declaration Start
    isPFBContinue: false,
    isPFBTOSContinue: false,
    isAutoPay: true,
    apDiscountInCart: false,
    paymentmodeSelection: "CHECKING",
    //PaperFreeBilling and AutoPay Declaration End
    getVzId: "",
    isgetVZIdUpdated: false,
    isBAUCreditCheckRequired: true,
    isrequiredCreditAssessment: true,
    faqCheckoutContent: '',
    PrevSelectedProudct: '',
    checkoutLoaded: false,
    //move Change
    discDateArr: [],
    availableDiscDates: [],
    selDisconnectDate: "", 
    isShippingSetFlag : "",
    selDisconnectDateFormatted: "",
    returnEquipmentSelect: "",
    returnEquipmentClick: false,
    onPFBProfileVerified: false,
    setDueDateAttempts: 0,
    emergencyNotification: {
        isConsentRequired: false,
        consentStatus: false,
        states: {},
        restrictVroom: false
    },
    screening: {
        questionaire: "",
        choiceSet: "",
        selectionOption: "",
        enableScreeningButton: false,
        displayTaggingFired: false,
        clickTaggingFired: false
    },
    covidRestriction: "",
    cancelPropensity: {
        isRequired: false,
        isInitiated: false,
        isSuccess: false
    },
    pendingCheckoutNotification: {
        displaySpecificErrorMessages : false
    },
    focusOnCalendar : false,
    pickupDeliverySelected:null,
    setupFeeExists: '',
    creditCheckThrottleFlag : false,
    isNonMTNTrackerAdded: false,
    showReviewOrderContent: true,
    showTosContent: true,
    debitAutopay : false,

};

const monthsJson = {
    "01": "January",
    "02": "February",
    "03": "March",
    "04": "April",
    "05": "May",
    "06": "June",
    "07": "July",
    "08": "August",
    "09": "September",
    "10": "October",
    "11": "November",
    "12": "December"
}

function checkout(state = initialState, action) {
    switch (action.type) {

        case 'GOTO_CHECKOUT_STEP':
            return Object.assign({}, state, {
                completedStep: state.completedStep.map((status, index) => index === state.activeStep ? true : status),
                activeStep: action.value
            })
        case CheckOut.updatePersonalInfoAccordionStatus:
            let personalInfoStatus = Object.assign({}, state.accordionStatus, {
                personalInfo: action.value
            })
            return Object.assign({}, state, {
                accordionStatus: personalInfoStatus,
                pendingCheckoutNotification : {...state.pendingCheckoutNotification, displaySpecificErrorMessages : false}
            })
        case CheckOut.updateSatelliteAccordionStatus:
            let satelliteInfoStatus = Object.assign({}, state.accordionStatus, {
                satellite: action.value
            })
            return Object.assign({}, state, {
                accordionStatus: satelliteInfoStatus,
                pendingCheckoutNotification : {...state.pendingCheckoutNotification, displaySpecificErrorMessages : false}
            })
        case CheckOut.updateCreditCheckAccordionStatus:
            let creditCheckStatus = Object.assign({}, state.accordionStatus, {
                creditCheck: action.value
            })
            return Object.assign({}, state, {
                accordionStatus: creditCheckStatus,
                pendingCheckoutNotification : {...state.pendingCheckoutNotification, displaySpecificErrorMessages : false}
            })
        case CheckOut.updateInstallationAccordionStatus:
            let InstallationStatus = Object.assign({}, state.accordionStatus, {
                installation: action.value
            })
            return Object.assign({}, state, {
                accordionStatus: InstallationStatus,
                pendingCheckoutNotification : {...state.pendingCheckoutNotification, displaySpecificErrorMessages : false}
            })
        case CheckOut.updateDeliveryOptionAccordion:
            let deliveryOptionStatus = Object.assign({}, state.accordionStatus, {
                deliveryOption: action.value
            })
            return Object.assign({}, state, {
                accordionStatus: deliveryOptionStatus,
                pendingCheckoutNotification : {...state.pendingCheckoutNotification, displaySpecificErrorMessages : false}
            })

        case CheckOut.updateDisconnectAccordionStatus:
            let disconnectStatus = Object.assign({}, state.accordionStatus, {
                disconnect: action.value
            })
            return Object.assign({}, state, {
                accordionStatus: disconnectStatus
        })    
        case CheckOut.PrevSelectedProd:
            let PrevSelectedProd = Object.assign({}, state.PrevSelectedProudct, {
                PrevSelectedProudct: action.value
            })
            return Object.assign({}, state, {
                PrevSelectedProudct: PrevSelectedProd
            })
        case CheckOut.updateAutoPayAccordionStatus:
            let autoPayStatus = Object.assign({}, state.accordionStatus, {
                autoPay: action.value
            })
            return Object.assign({}, state, {
                accordionStatus: autoPayStatus,
                pendingCheckoutNotification : {...state.pendingCheckoutNotification, displaySpecificErrorMessages : false}
            })
        case CheckOut.updateReviewOrderAccordionStatus:
            let reviewOrderStatus = Object.assign({}, state.accordionStatus, {
                reviewOrder: action.value
            })
            return Object.assign({}, state, {
                accordionStatus: reviewOrderStatus,
                pendingCheckoutNotification : {...state.pendingCheckoutNotification, displaySpecificErrorMessages : false}
            })
        case CheckOut.updateTosAccordionStatus:
            let tosStatus = Object.assign({}, state.accordionStatus, {
                tos: action.value
            })
            return Object.assign({}, state, {
                accordionStatus: tosStatus,
                pendingCheckoutNotification : {...state.pendingCheckoutNotification, displaySpecificErrorMessages : false}
            })
        case CheckOut.updateDepositAccordionStatus:
            let depositStatus = Object.assign({}, state.accordionStatus, {
                deposit: action.value
            })
            return Object.assign({}, state, {
                accordionStatus: depositStatus
            })

        case CheckOut.onLoaderStatus:
            if (action.value === true) {
                return Object.assign({}, state, {
                    isLoaderActive: true
                })
            }
            else {
                return Object.assign({}, state, {
                    isLoaderActive: false
                })
            }
        case 'CO_VALIDATE_CART_SUCCESS':
            let Status = Object.assign({}, state.accordionStatus, {
                autoPay: 'completed'
            })
            return Object.assign({}, state, {
                isValidateCart: true,
                skipAutoPay : action.value.skipAutoPay ? action.value.skipAutoPay : '',
                accordionStatus: action.value.required ? Status : state.accordionStatus,
            })
        case 'CO_VALIDATE_CART_FAILURE':
            return Object.assign({}, state, {
                isValidateCart: false
            })
        case 'SET_SWITCHINSTALL_OPTIONS':
            return Object.assign({}, state, {
                switchInstallOptions: !action.value
            })
        case 'SET_INSTALL_DATE':
            return Object.assign({}, state, {
                selInstallDate: action.value.selInstallDate,
                selInstallDateFormatted: action.value.selInstallDateFormatted
            })
        case 'SET_INSTALL_TIME_SLOT':
            return Object.assign({}, state, {
                selInstallTimeSlot: action.value.displayTime,
                selInstallTimeSlotReserved: action.value.reserveTime
            })
        case 'STORE_DETAILS': 
            return Object.assign({}, state, {
                storedetailslist: action.value
            })
        case 'CHANGE_INSTALL_CALENDAR':
            let dateArr = [];
            switch (action.value.selDeliveryOption) {
                case "Mail":
                    dateArr = state.selfMailDateArr;
                    break;
                case "PickUp":
                    dateArr = state.selfPickupDateArr;
                    break;
                case "SDD":
                    dateArr = state.selfMailDateArr;
                    break;
                case "Locker":
                    dateArr = state.lockerdueDateArr;
                    break;
                default:
                    dateArr = state.dueDateArr;
                    break;

            }
            return Object.assign({}, state, {
                selDueDateType: action.value.selDueDateType,
                selDeliveryOption: action.value.selDeliveryOption,
                calenderDisplayArr: dateArr
            })
        case 'CHANGE_INSTALL_CALENDAR_VEC':
                return Object.assign({},state, { 
                    selDueDateType_new: action.value
                })
        case 'TOGGLE_DIRECT_SHIP_SECTION':
            return Object.assign({}, state, {
                showDirectShipSection: !state.showDirectShipSection
            })
        case 'SET_DIRECT_SHIP_EARLIEST_DATE':
            return Object.assign({}, state, {
                selEarliestDate: action.value
            })
        case 'SET_DIRECT_SHIP_SELECTION':
            return Object.assign({}, state, {
                dsInput: action.value
            })
            case CheckOut.ftcChecked:
                return Object.assign({}, state, {
                    ftcCheck: action.value
                })
        case CheckOut.tosChecked:
            return Object.assign({}, state, {
                tosCheck: action.value
            })
        case CheckOut.tosMonthlyServiceDisclosureChecked:
            return Object.assign({}, state, {
                tosMSDCheck: action.value
            })
        case CheckOut.privacyChecked:
                return Object.assign({}, state, {
                    privacyCheck: action.value
                })    
        case CheckOut.hdpChecked:
            return Object.assign({}, state, {
                    hdpCheck: action.value
           })
           case CheckOut.homeSecurityChecked:
            return Object.assign({}, state, {
                    homeSecurityChecked: action.value
           })
           case CheckOut.homeSecureChecked:
            return Object.assign({}, state, {
                homeSecureChecked: action.value
           })

        case 'SHOW_TOS_ERROR_MSG':
            return Object.assign({}, state, {
                showTosError: action.value
            })
            case 'SHOW_TOS_VOICE_ERR_MSG':
                return Object.assign({},state, {
                    showTosVoiceError: action.value
            })
        case "SHOW_TOS_VHDP_ERROR_MSG":
            return Object.assign({}, state, {
                showTosVHDPError: action.value
            });
        case CheckOut.tosVoiceChecked:
            if(!action.value){
            return Object.assign({}, state, {
                tosVoiceCheck: !action.value,
                showTosVoiceError: false
            })
            }
            else{
                return Object.assign({}, state, {
                    tosVoiceCheck: !action.value
                }) 
            }
        case CheckOut.tosViewed:
            return Object.assign({}, state, {
                tosViewed: action.value
            })
            case 'SET_AP_ENROLL_CHECKOUT':
            return Object.assign({}, state, {
                isautopayenrollincheckout: action.value
            })
        case CheckOut.onPFBClick:
            if (action.value === "PFB") {
                return Object.assign({}, state, {
                    isPFBContinue: !state.isPFBContinue,
                })
            }
            if (action.value === "PFBContinueTos") {
                return Object.assign({}, state, {
                    isPFBTOSContinue: !state.isPFBTOSContinue
                })
            }
            break;
        case CheckOut.onPaymentModeChange:
            return Object.assign({}, state, {
                paymentmodeSelection: action.value
            })
        case CheckOut.onCheckAutoPayOffer:
            return Object.assign({}, state, {
                isAutoPay: action.value
            })
        case 'AP_DISCOUNT_INCART':
            return Object.assign({}, state, {
                apDiscountInCart: action.value
            })
        case CheckOut.onDueDateSuccess:
            let directShipData = [];
            let { duedates, dispatchType, intervalReason, discDuedates,tech, flowType } = action.value;
            intervalReason = state.intervalReason || intervalReason || 'N';
            if (dispatchType === "O") {
                duedates.map(obj => {
                    if (obj.directShip === "Y") {
                        directShipData.push({ dShipDate: obj.dueDate, earliestDate: obj.earliestDirectShipDate });
                    }
                    return directShipData;
                })
            }
            if(dispatchType==="O"&&tech==="Y"){
                console.log('due dates',duedates)
            const objDueDate_Tech = duedates.map(obj => obj.dueDate);
            const techInstallnDirectShip_Tech = (dispatchType === "O" && duedates.length && duedates[0].directShip === "Y");
            const firstDueDate_Tech = duedates[0];
            const lockerdueDateArr_Tech = action.value.package ? action.value.package.map(obj => obj.dueDate) : null;
            const discDateArr_Tech = discDuedates && discDuedates.length ? discDuedates.map(obj => obj.dueDate) : [];
            const selDisconnectDate_Tech = discDateArr_Tech.length && discDateArr_Tech[0] || '';
            let selInstallDateFormatted_Tech = '', selDisconnectDateFormatted_Tech = '';
            if (firstDueDate_Tech.dueDate) {
                const arrSelDate_Tech = firstDueDate_Tech.dueDate.split('/');
                selInstallDateFormatted_Tech = arrSelDate_Tech.length === 3 && monthsJson[arrSelDate_Tech[0]] + ' ' + arrSelDate_Tech[1] + ', ' + arrSelDate_Tech[2] || '';
            }
            if (selDisconnectDate_Tech) {
                const arrSelDisDate_Tech = selDisconnectDate_Tech.split('/');
                selDisconnectDateFormatted_Tech = arrSelDisDate_Tech.length === 3 && monthsJson[arrSelDisDate_Tech[0]] + ' ' + arrSelDisDate_Tech[1] + ', ' + arrSelDisDate_Tech[2] || '';
            }
    
            return Object.assign({}, state, {
                 dueDateResponse_Tech: duedates,
                // dueDateResponse: dispatchType === "I"?duedates:[],
                // selfInstallCapable : dispatchType === "I"? "Y": "N",
                // testSelfinstall : dispatchType === "I"? "Y": "N",
                dueDateArr_Tech: objDueDate_Tech,
                selDueDateType_Tech:  "TECHVISIT",
                // selDueDateType : "EONTSELFINSTALL",
                // dueDateMonday: dispatchType === "O"? duedates: [],
                installTimeSlots_Tech: firstDueDate_Tech.timeInterval,
                selInstallDate_Tech: firstDueDate_Tech.dueDate,
                isDueDateCall: true,
                showDirectShipSection_Tech: techInstallnDirectShip_Tech,
                directShipDates_Tech: directShipData,
                selInstallTimeSlot_Tech: (firstDueDate_Tech.timeInterval && firstDueDate_Tech.timeInterval.length) ? firstDueDate_Tech.timeInterval[0].displayTime : "",
                selInstallTimeSlotReserved_Tech: (firstDueDate_Tech.timeInterval && firstDueDate_Tech.timeInterval.length > 0) ? firstDueDate_Tech.timeInterval[0].reserveTime : "",
                selEarliestDate: techInstallnDirectShip_Tech ? firstDueDate_Tech.earliestDirectShipDate : "",
                calenderDisplayArr_Tech: objDueDate_Tech,
                lockerdueDateArr_Tech,
                selfMailDateArr_Tech: objDueDate_Tech,
                selfPickupDateArr_Tech: objDueDate_Tech,
                // selfMailDateArr: state.selfMailDateArr && state.selfMailDateArr.length ? state.selfMailDateArr : objDueDate,
                // selfPickupDateArr: state.selfPickupDateArr  && state.selfPickupDateArr.length  ? state.selfPickupDateArr : objDueDate,
                //move Change
                discDateArr_Tech,
                selDisconnectDate_Tech,
                intervalReason,
                selInstallDateFormatted_Tech,
                selDisconnectDateFormatted_Tech
            })

            }else{
            const objDueDate = duedates.map(obj => obj.dueDate);
            const techInstallnDirectShip = (dispatchType === "O" && duedates.length && duedates[0].directShip === "Y");
            const firstDueDate = duedates[0];
            const lockerdueDateArr = action.value.package ? action.value.package.map(obj => obj.dueDate) : null;
            const discDateArr = discDuedates && discDuedates.length ? discDuedates.map(obj => obj.dueDate) : [];
            const selDisconnectDate = flowType != "MV" && discDateArr.length && discDateArr[0] || '';
            let selInstallDateFormatted = '', selDisconnectDateFormatted = '';
            if (firstDueDate.dueDate) {
                const arrSelDate = firstDueDate.dueDate.split('/');
                selInstallDateFormatted = arrSelDate.length === 3 && monthsJson[arrSelDate[0]] + ' ' + arrSelDate[1] + ', ' + arrSelDate[2] || '';
            }
            if (selDisconnectDate) {
                const arrSelDisDate = selDisconnectDate.split('/');
                selDisconnectDateFormatted = arrSelDisDate.length === 3 && monthsJson[arrSelDisDate[0]] + ' ' + arrSelDisDate[1] + ', ' + arrSelDisDate[2] || '';
            }

            return Object.assign({}, state, {
                 dueDateResponse: duedates,
                // dueDateResponse: dispatchType === "I"?duedates:[],
                dueDateArr: objDueDate,
                // selfInstallCapable : dispatchType === "I"? "Y": "N",
                // testSelfinstall : dispatchType === "I"? "Y": "N",
                selDueDateType: dispatchType === "I" ? "EONTSELFINSTALL" : "TECHVISIT",
                // selDueDateType : "EONTSELFINSTALL",
                // dueDateMonday: dispatchType === "O"? duedates: [],
                installTimeSlots: firstDueDate.timeInterval,
                selInstallDate: firstDueDate.dueDate,
                isDueDateCall: true,
                showDirectShipSection: techInstallnDirectShip,
                directShipDates: directShipData,
                selInstallTimeSlot: (firstDueDate.timeInterval && firstDueDate.timeInterval.length) ? firstDueDate.timeInterval[0].displayTime : "",
                selInstallTimeSlotReserved: (firstDueDate.timeInterval && firstDueDate.timeInterval.length > 0) ? firstDueDate.timeInterval[0].reserveTime : "",
                selEarliestDate: techInstallnDirectShip ? firstDueDate.earliestDirectShipDate : "",
                calenderDisplayArr: objDueDate,
                lockerdueDateArr,
                selfMailDateArr: objDueDate,
                selfPickupDateArr: objDueDate,
                // selfMailDateArr: state.selfMailDateArr && state.selfMailDateArr.length ? state.selfMailDateArr : objDueDate,
                // selfPickupDateArr: state.selfPickupDateArr  && state.selfPickupDateArr.length  ? state.selfPickupDateArr : objDueDate,
                //move Change
                discDateArr,
                selDisconnectDate,
                intervalReason,
                selInstallDateFormatted,
                selDisconnectDateFormatted
            })
        }

        case CheckOut.resetDueDate:
            return Object.assign({}, state, {
                dueDateResponse: null,
                dueDateArr: null,
                selDueDateType: '',
                installTimeSlots: '',
                selInstallDate: '',
                showDirectShipSection: false,
                directShipDates: null,
                selInstallTimeSlot: '',
                selInstallTimeSlotReserved: "",
                selEarliestDate: "",
                calenderDisplayArr: null,
                lockerdueDateArr: null,
                selfMailDateArr: null,
                selfPickupDateArr: null,
                isDueDateCall: false,
                intervalReason: ''
            })

        case CheckOut.resetDueDateMsg:
            const { resetDD, attemptExceeded } = action.value;
            // increment the counter, if attemptExceeded is true, else set the counter to 0
            const setDueDateAttempts = attemptExceeded ? state.setDueDateAttempts + (+attemptExceeded) : (+attemptExceeded);
            return Object.assign({}, state, {
                displayResetDueDateMsg: resetDD,
                resetDDattemptExceeded: setDueDateAttempts > 2,
                setDueDateAttempts
            })

        case CheckOut.productChangedResetDueDate:
            return Object.assign({}, state, {
                dueDateResponse: null,
                dueDateArr: null,
                installTimeSlots: null,
                displayResetDueDateMsg: false,
                resetDDattemptExceeded: false,
                lockerdueDateArr: null,
                selDueDateType: "",
                isDueDateCall: false,
                setDueDateAttempts: 0,
                selEarliestDate: '',
                selInstallDate: "",
                selInstallDateFormatted: "",
                selInstallTimeSlot: "",
                selInstallTimeSlotReserved: "",
                selfMailDateArr: [],
                selfPickupDateArr: [],
                // for techvisit only
                directShipDates: null,//tempDirectShipDates,
                showDirectShipSection: false,
                dsInput: "",
                calenderDisplayArr: null,
                isStorePickupEnabled: false,
                intervalReason: ''
            })
        case CheckOut.updateStorePickUpData:
            return Object.assign({}, state, {
                storeLocations: action.value,
                isStorePickupEnabled: action.value.length > 0 ? true : false
            })
        case CheckOut.updatePackageLockerData:
            return Object.assign({}, state, {
                packageLockerLocation: action.value,
                isPackageLockerAvailable: action.value.length > 0 && state.lockerdueDateArr != null ? true : false,
                calenderDisplayArr: action.value.length > 0 && state.lockerdueDateArr != null ? state.lockerdueDateArr : state.calenderDisplayArr,
                selDeliveryOption: action.value.length > 0 && state.lockerdueDateArr != null ? "Locker" : state.selDeliveryOption
            })
        case 'UPDATE_TIME_SLOTS':
            return Object.assign({}, state, {
                installTimeSlots: action.value,
                selInstallTimeSlot: action.value[0].displayTime,
                selInstallTimeSlotReserved: action.value[0].reserveTime
            })
        case CheckOut.onSetDueDate:
            return Object.assign({}, state, {
                isInstallationDone: action.value
            })
        case CheckOut.updateSameDayDelivery:
            return Object.assign({}, state, {
                isSameDayDeliveryAvbl: action.value
            })
        case 'GENERATE_VZID':
            return Object.assign({}, state, {
                getVzId: action.value
            })
        case 'VZIDUPDATED':
            return Object.assign({}, state, {
                isgetVZIdUpdated: action.value
            })
        case CheckOut.satelliteEligible:
            return Object.assign({}, state, {
                satelliteEligible: action.value
            })
        case CheckOut.satelliteOption:
            return Object.assign({}, state, {
                satelliteSelect: action.value
            })
        case CheckOut.satelliteClick:
            return Object.assign({}, state, {
                satelliteClick: action.value
            })
        case CheckOut.updateBAUCC:
            return Object.assign({}, state, {
                isBAUCreditCheckRequired: action.value
            })

        case MTNValidation.updateisAssessmentRequired:
            return Object.assign({}, state, {
                isrequiredCreditAssessment: action.value
            })
        case "NON_MTN_TRACKER_UPDATED":
            return Object.assign({}, state, {
                isNonMTNTrackerAdded: action.value
            })
        case "TOGGLE_REVIEW_ORDER_VIEW":
            return Object.assign({}, state, {
                showReviewOrderContent: !action.value
            })
        case "TOGGLE_TOS_VIEW":
            return Object.assign({}, state, {
                showTosContent: !action.value
            })
        case "DEBIT_AUTOPAY_FLAG":
            return Object.assign({}, state, {
                debitAutopay: action.value
            })
        case "FAQ_CHECKOUT_CONTENT":
            return Object.assign({}, state, {
                faqCheckoutContent: action.value
            })
        //move Change
        case CheckOut.mvCheckout:
            return Object.assign({}, state, {
                mvCheckout: action.value
            })
        case CheckOut.updateReturnEquipAccordianStatus:
            let returnEquipmentStatus = Object.assign({}, state.accordionStatus, {
                returnEquipment: action.value
            })
            return Object.assign({}, state, {
                accordionStatus: returnEquipmentStatus
            })
        case 'SET_DISCONNECT_DATE':
            return Object.assign({}, state, {
                selDisconnectDate: action.value.selDiscDate,
                selDisconnectDateFormatted: action.value.selDiscDateFormatted
            })
        case CheckOut.onPFBProfileVerified:
            return Object.assign({}, state, {
                onPFBProfileVerified: action.value
            })
        case CheckOut.returnEquipmentOption:
            return Object.assign({}, state, {
                returnEquipmentSelect: action.value
            })
        case CheckOut.returnEquipmentClick:
            return Object.assign({}, state, {
                returnEquipmentClick: action.value
            })
        case 'SET_SHIPPING_STATUS':
                return Object.assign({}, state, {
                    isShippingSetFlag : action.value
                })  
        case CheckOut.fiabSelectedOption:
            const { fiabSelectedOption } = action;
            return Object.assign({}, state, {
                fiabSelectedOption
            })
        case 'UPDATE_AVAILABLE_DISC_DATES':
            return Object.assign({}, state, {
                availableDiscDates: action.value
            })
        case CheckOut.checkoutLoaded:
            return Object.assign({}, state, {
                checkoutLoaded: action.value
            })
        case 'EMERGENCY_NOTIFICATION_CONSENT_REQUIRED':
            let emergencyNotificationConsentRequired = Object.assign({}, state.emergencyNotification, {
                isConsentRequired: action.value
            })
            return Object.assign({}, state, {
                emergencyNotification: emergencyNotificationConsentRequired
            })
        case 'EMERGENCY_NOTIFICATION_CONSENT':
            let emergencyNotificationConsent = Object.assign({}, state.emergencyNotification, {
                consentStatus: action.value
            })
            return Object.assign({}, state, {
                emergencyNotification: emergencyNotificationConsent
            })
        case 'EMERGENCY_NOTIFICATION_RESTRICT_VROOM':
            let emergencyNotificationVroom = Object.assign({}, state.emergencyNotification, {
                restrictVroom: action.value
            })
            return Object.assign({}, state, {
                emergencyNotification: emergencyNotificationVroom
            })
        case 'SCREENING_CHOICE_SET':
            let screeningChoiceSet = Object.assign({}, state.screening, {
                choiceSet: action.value
            })
            return Object.assign({}, state, {
                screening: screeningChoiceSet
            })
        case 'SCREENING_QUESTIONAIRE':
            let screeningQuestionaire = Object.assign({}, state.screening, {
                questionaire: action.value
            })
            return Object.assign({}, state, {
                screening: screeningQuestionaire
            })
        case 'SCREENING_SELECTED_OPTION':
            let screeningSelectionOption = Object.assign({}, state.screening, {
                selectionOption: action.value
            })
            return Object.assign({}, state, {
                screening: screeningSelectionOption
            })
        case 'SCREENING_ENBALE_BUTTON':
            let screeningEnableButton = Object.assign({}, state.screening, {
                enableScreeningButton: action.value
            })
            return Object.assign({}, state, {
                screening: screeningEnableButton
            })
        case 'FOCUS_CALENDAR':
            return Object.assign({}, state, {
                focusOnCalendar: action.value
            })
        case 'DUEDATE_COVID_RESTRICTION':
            return Object.assign({}, state, {
                covidRestriction: action.value
            })
        case 'SCREENING_DISPLAY_TAGGING_FIRED':
            let isDisplayTaggingFired = Object.assign({}, state.screening, {
                displayTaggingFired: action.value
            })
            return Object.assign({}, state, {
                screening: isDisplayTaggingFired
            })
        case 'SCREENING_CLICK_TAGGING_FIRED':
            let isClickTaggingFired = Object.assign({}, state.screening, {
                clickTaggingFired: action.value
            })
            return Object.assign({}, state, {
                screening: isClickTaggingFired
            })
        case 'CANCEL_PROPENSITY_CALL_REQUIRED':
            let isCancelPropensityCallRequired = Object.assign({}, state.cancelPropensity, {
                isRequired: action.value
            })
            return Object.assign({}, state, {
                cancelPropensity: isCancelPropensityCallRequired
            })
        case 'CANCEL_PROPENSITY_CALL_INITIATED':
            let isCancelPropensityCallInitiated = Object.assign({}, state.cancelPropensity, {
                isInitiated: action.value
            })
            return Object.assign({}, state, {
                cancelPropensity: isCancelPropensityCallInitiated
            })
        case 'CANCEL_PROPENSITY_CALL_SUCCESS':
            let isCancelPropensityCallSuccess = Object.assign({}, state.cancelPropensity, {
                isSuccess: action.value
            })
            return Object.assign({}, state, {
                cancelPropensity: isCancelPropensityCallSuccess
            })
        case "EMPTY_CHECKOUT":
            return initialState
        case 'EC_CLEAR_CHECKOUT_STATUS':
            let accordionStatus = Object.assign({}, state.accordionStatus, {
                personalInfo: 'required',
                satellite: 'required',
                creditCheck: 'required',
                installation: 'required',
                autoPay: 'required',
                tos: 'required',
                deposit: 'required',
                disconnect: 'required',
                returnEquipment: 'required'
            })
            return Object.assign({}, state, {
                accordionStatus: accordionStatus
            })
        case 'STORESELFTOTECHFLAG':
                return Object.assign({}, state, {
                    selfToTechFlag: action.value
                })    
        case "DISPLAY_PENDING_CHECKOUT":
            let notificationCheckout = Object.assign({}, state.pendingCheckoutNotification, {
                displaySpecificErrorMessages : action.value
            })
            return Object.assign({}, state, {
                pendingCheckoutNotification: notificationCheckout
            })
        case 'STORE_DELIVERY_METHOD':
            return{
                ...state,
                pickupDeliverySelected:action.value
            } 
        case 'CLEAR_SELECTED_DISC_DATE':
            return Object.assign({}, state, {
                selDisconnectDate: "",
                selDisconnectDateFormatted: ""
            })
        case 'SETUP_FEE':
            return Object.assign({}, state, {
                setupFeeExists: action.value
            })
          //Removing Logic based on ACt112-516 
        // case 'UPDATE_CREDITCHECK_THROTTLE':
        //     return Object.assign({}, state, {
        //         creditCheckThrottleFlag: action.value
        //     })   
        default:
            return state
    }
}

export default checkout